import React from "react";
import Container from "@/components/marketing/Container";
import SectionHeading from "@/components/marketing/SectionHeading";
import { Clock, Languages, BadgeCheck, Newspaper, Image as ImageIcon, FileCheck } from "lucide-react";

const ITEMS = [
  {
    icon: Newspaper,
    title: "80 Media Pickups",
    desc: "Your release is picked up across Gulf media, 40 English and 40 Arabic placements, with live links in your coverage reports.",
  },
  {
    icon: Clock,
    title: "Same-Day Submission",
    desc: "Submit today and your release goes out the same day. Distribution typically begins within 30 minutes once your release is approved and ready.",
  },
  {
    icon: Languages,
    title: "Arabic Translation Included",
    desc: "Native Arabic translation is included. You can distribute in English first and follow with Arabic, and review the translation before it goes out.",
  },
  {
    icon: BadgeCheck,
    title: "Guaranteed Key Sites",
    desc: "Placement on key regional news sites including Zawya, MENA FN, and Business Arabia.",
  },
  {
    icon: ImageIcon,
    title: "Multimedia Included",
    desc: "Include images and video with your release at no extra cost.",
  },
  {
    icon: FileCheck,
    title: "Two Coverage Reports",
    desc: "You receive a coverage report at 2 days and a final report at 10 days, with live links showing where your story landed.",
  },
];

export default function GulfNewswireIncluded() {
  return (
    <section className="py-12 lg:py-16 bg-slate/30">
      <Container>
        <SectionHeading
          tag="WHAT'S INCLUDED"
          title="Everything in the Gulf newswire."
          subtitle="One fixed price covers syndication, translation, multimedia, and reporting."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="group bg-white border border-border rounded-xl p-7 flex flex-col hover:border-cobalt/30 transition-colors"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-cobalt/5 mb-5">
                <item.icon className="w-6 h-6 text-cobalt" strokeWidth={1.75} />
              </div>
              <h3 className="font-heading text-lg font-bold text-bone mb-2">{item.title}</h3>
              <p className="text-sm text-steel leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}